// extracted by mini-css-extract-plugin
export var breadcrumb = "_z-2";
export var breadcrumbArrow = "_z-3";
export var breadcrumbs = "_z-0";
export var link = "_z-4";
export var small = "_z-1";